module.exports = __webpack_public_path__ + "media/packs/images/flags/UA-4f4c8bba2d31bccee2bc88942b5082e4.png";